import React from 'react';
import { Text, Pane, Button, Toast } from '@leverege/ui-elements';
import { Blueprint } from '@leverege/molten/imagine';
import { GlobalState } from '@leverege/ui-redux';
import Molten from '@leverege/molten';
import { SKU_BLUEPRINT_MAP } from '../../../constants';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const strings = {
  errors: numErrors => `${numErrors || 0} Error${numErrors !== 1 ? 's' : ''} Detected`,
  activeSuccesses: (numSuccesses, numItems, action, typeName) => {
    return `Approximately ${numSuccesses || 0}/${numItems || 'Unknown'} ${typeName(numSuccesses)} Successfully ${action}ed`;
  },
  completeSuccess: (numItems, typeName, action) => `${numItems} ${typeName(numItems)} Successfully ${action}ed`,
  completeError: message => `Job failed completely ${message ? ` with error: ${message}` : ''}`
};
function Header(props) {
  const {
    state
  } = props;
  let content, icon;
  switch (state) {
    case 'success':
      content = 'Job Complete';
      icon = 'https://recovr-ui-assets.storage.googleapis.com/success.png';
      break;
    case 'error':
      content = 'Job Error';
      icon = 'https://recovr-ui-assets.storage.googleapis.com/system-fail-icon.svg';
      break;
    case 'active':
    default:
      content = 'Job Active';
      icon = null;
  }
  return /*#__PURE__*/_jsx(Text, {
    imageOpts: {
      height: '24px',
      width: '24px'
    },
    icon: icon,
    variant: "title",
    children: content
  });
}
const colors = {
  error: 'var( --color-danger500',
  success: 'var( --color-success500 )',
  active: 'var( --color-brand500 )',
  default: 'var( --color-brand500 )'
};
function Progress(props) {
  const {
    total,
    complete,
    state
  } = props;
  if (state === 'error') {
    return null;
  }
  const color = colors[state] || colors.default;
  const percent = Math.ceil(total / complete) || 0;
  return /*#__PURE__*/_jsx(Pane, {
    layout: "flex:rowMCenter",
    variant: "jobProgressBarContainer",
    children: /*#__PURE__*/_jsx(Pane, {
      variant: "jobProgressBar",
      style: {
        backgroundColor: color,
        width: `calc( ${percent * 100}% - ${percent * 4}px )`
      }
    })
  });
}
async function retry(item) {
  const type = SKU_BLUEPRINT_MAP[item.data?.sku];
  const jobId = item.data.jobId;
  const server = type === 'locator' || type === 'beacon' ? 'recovrLogUpload' : 'kudelskidevice';
  try {
    await GlobalState.dispatch(async (dispatch, getState, {
      api
    }) => {
      const systemId = Molten.getConfig('api/systemId');
      await api.system(systemId).srv(server).post(`job/${jobId}/retry`);
    });
    Toast.success(`Retrying job ${jobId}`);
  } catch (err) {
    console.error(err);
    Toast.error([`Unable to retry job ${jobId} log`, err?.message]);
  }
}
function Details(props) {
  const {
    item
  } = props;
  let content,
    btn = null;
  const objType = SKU_BLUEPRINT_MAP[item?.data?.sku];
  const bp = Blueprint.getByType(objType);
  const typeName = num => {
    return num === 1 ? bp.name : bp.namePlural;
  };
  const pluralErrors = item?.data?.numErrors !== 1;
  const action = item?.data?.type?.includes('upload') ? 'upload' : 'revert';
  switch (item?.data?.state) {
    case 'success':
      content = /*#__PURE__*/_jsx(Text, {
        children: strings.completeSuccess(item?.data?.numItems, typeName, action)
      });
      break;
    case 'error':
      if (item?.numSuccesses == null && item?.data?.numErrors == null) {
        content = /*#__PURE__*/_jsx(Text, {
          children: strings.completeError(item?.data?.errorMessage)
        });
      } else {
        content = /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs(Text, {
            children: [item?.data?.numSuccesses || 0, " ", typeName(item?.data?.numSuccesses), " Successfully ", action]
          }), /*#__PURE__*/_jsx(Text, {
            children: strings.errors(item?.data?.numErrors)
          })]
        });
        btn = item?.data?.parentJob ? /*#__PURE__*/_jsxs(Button, {
          onClick: () => retry(item),
          children: ["Re-Run Error", pluralErrors ? 's' : '']
        }) : null;
      }
      break;
    case 'pending':
      content = /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Text, {
          children: strings.activeSuccesses(item?.data?.numSuccesses, item?.data?.numItems, action, typeName)
        }), /*#__PURE__*/_jsx(Text, {
          children: strings.errors(item?.data?.numErrors)
        })]
      });
      break;
    case 'active':
    default:
      content = /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Text, {
          children: strings.activeSuccesses(item?.data?.numSuccesses, item?.data?.numItems, action, typeName)
        }), /*#__PURE__*/_jsx(Text, {
          children: strings.errors(item?.data?.numErrors)
        })]
      });
  }
  return /*#__PURE__*/_jsxs(Pane, {
    layout: "flex:rowSpaceBetween",
    children: [/*#__PURE__*/_jsx(Pane, {
      layout: "flex:colM",
      children: content
    }), btn]
  });
}
function ProgressCardViewer(props) {
  const {
    sharedProps: {
      item,
      delegate
    }
  } = props;
  if (item == null) {
    return null;
  }
  const {
    state
  } = item.data;
  return /*#__PURE__*/_jsxs(Pane, {
    layout: "flex:colL",
    variant: "progressDetail",
    children: [/*#__PURE__*/_jsx(Header, {
      state: state,
      delegate: delegate
    }), /*#__PURE__*/_jsx(Progress, {
      total: item?.data?.numItems,
      complete: item?.data?.numSuccesses,
      state: state,
      delegate: delegate
    }), /*#__PURE__*/_jsx(Details, {
      item: item,
      delegate: delegate
    })]
  });
}
export default ProgressCardViewer;
// export default createCardConnect( ProgressCardViewer, ProgressCardModel )